import React, { Component } from 'react'
import { withStyles, Popover, Grid, TextField } from '@material-ui/core'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import Button from 'components/ButtonMaterial'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { showFlashMessage, showFlashMessageOnUnexpectedError, flagProperty } from 'actions'
import isempty from 'lodash.isempty'
import CircularProgress from '@material-ui/core/CircularProgress'

const styles = theme => ({
  paper: {
    borderRadius: '0',
    width: '320px',
    padding: '10px 30px 20px',
    top: 'auto !important',
    bottom: '10px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  buttonProgress: {
    color: '#fff',
  },
  paymentCardheading: {
    fontSize: '27px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '20px',
    },
  },
  paymentCardprice: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#a9aeba',
    marginTop: '5px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '0px',
    },
  },
  reportBtn: {
    width: '100px',
    height: '28px',
    borderRadius: '4px',
    fontSize: '13px',
    fontWeight: '500',
    backgroundColor: '#ef4135',
    color: 'rgba(255, 255, 255, 0.8)',
    '& span': {
      height: 'auto',
      lineHeight: '1.31',
    },
    '&:hover': {
      backgroundColor: '#ef4135',
      color: 'rgba(255, 255, 255, 0.8)',
    },
  },
  textFieldFullWidth: {
    marginBottom: '24px',
    '& > label': {
      textTransform: 'uppercase',
    },
  },
  cssUnderline: {
    padding: '0',
    '& textarea': {
      margin: '10px 0 0',
      height: '100px !important',
      overflow: 'auto',
    },
    '&:hover': {
      '&:before': {
        borderBottomColor: '#ececec !important',
      },
    },
    '&:before': {
      borderBottomColor: '#ececec',
    },
    '&:after': {
      borderBottomColor: 'transparent',
    },
  },
  cssLabel: {
    textTransform: 'uppercase',
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '1.54',
    '&$cssFocused': {
      color: '#a9aeba',
    },
    color: 'rgba(0, 0, 0, 0.2)',
  },
  cssInputLabel: {
    '&$cssFocused': {
      color: '#00bcb5',
    },
    color: 'rgba(0, 0, 0, 0.2)',
  },
  cssLabelError: {
    color: '#f00',
  },
  cssFocused: {
    color: '#00bcb5',
  },

  selectControl: {
    outline: 'none',
    width: '100%',
    marginBottom: '10px',
  },
  selectControlLabel: {
    textTransform: 'uppercase',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '1.54',
    color: 'rgba(0, 0, 0, 0.2)',
    transform: 'none',
    '&$focused': {
      color: '#000',
    },
  },

  selectControlDropdown: {
    '& div': {
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
  },
})

const fields = ['reason']
const OTHER = 'Other'
class ReasonForm extends Component {
  constructor(props) {
    super(props)
    this.state = fields.reduce((output, field) => ({ ...output, [field]: '' }), { errors: {}, loading: false, otherReason: '', isOther: false })
  }

  onFormFieldChange = event => {
    const target = event.target
    const name = target.name || 'reason'
    const value = target.value
    if (name === 'reason') {
      this.setState({
        isOther: value === OTHER,
      })
    }
    this.setState(state => ({
      [name]: value,
      errors: { ...state.errors, [name]: this.validateField(name, value) },
    }))
  }

  validateField = (name, value) => {
    if (value === '') {
      return 'is missing'
    } else if (value === null || value === undefined) {
      return 'is invalid'
    }

    switch (name) {
      case 'reason': {
        if ('' === value.trim()) {
          return 'is invalid'
        }
        break
      }
      default:
        break
    }
  }

  isValid = () => {
    if (!this.state.isOther) {
      return fields.reduce((a, f) => a && this.state[f] && !this.state.errors[f], true)
    } else {
      return this.state.otherReason && !this.state.errors['otherReason']
    }
  }

  handleSubmit = async event => {
    event.preventDefault()
    if (this.isValid()) {
      this.loadingState()
      try {
        const response = await this.props.flagProperty({
          id: this.props.propertyId,
          token: this.props.user.token,
          reason: this.state.isOther ? this.state.otherReason : this.state.reason,
          from: this.props.listing,
        })
        this.loadingState()
        if (isempty(response.errors)) {
          this.props.propertyRemoved(this.props.listing)
          this.props.onClose()
          this.props.handleClose()
          this.props.showFlashMessage(null, `Property has been flagged!`)
        } else {
          this.props.showFlashMessage(true, response.errors.map(field => `${field[0]} ${field[1].join(', ')}`).join(';'))
        }
      } catch (error) {
        this.loadingState()
        this.props.showFlashMessageOnUnexpectedError(error)
      }
    }
  }

  loadingState = () => {
    this.setState(prevState => ({
      loading: !prevState.loading,
    }))
  }

  render() {
    const { open, onClose, classes, anchorEl } = this.props
    const labelProps = {
      shrink: true,
      FormLabelClasses: {
        root: classes.cssLabel,
        focused: classes.cssFocused,
        error: classes.cssLabelError,
      },
    }
    const { reason, errors, loading, otherReason, isOther } = this.state
    const id = open ? 'requestForm' : undefined
    return (
      <div>
        <Popover
          anchorEl={anchorEl}
          classes={{ paper: classes.paper }}
          id={id}
          open={open}
          onClose={() => onClose()}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}>
          <form noValidate autoComplete="off">
            <Grid item className={classes.grid}>
              <FormControl className={`${classes.formControl} ${classes.selectControl}`}>
                <InputLabel FormLabelClasses={{ root: classes.cssLabel, focused: classes.cssFocused }} className={classes.selectControlLabel} id="reason">
                  Select Reason
                </InputLabel>
                <Select
                  className={`${classes.selectControlDropdown} ${classes.cssUnderline}`}
                  labelId="reason"
                  id="reason"
                  name="reason"
                  value={reason}
                  onChange={this.onFormFieldChange}>
                  <MenuItem value={'Inaccurate information'}>Inaccurate information</MenuItem>
                  <MenuItem value={'Irrelevant information'}>Irrelevant information</MenuItem>
                  <MenuItem value={OTHER}>{OTHER}</MenuItem>
                </Select>
              </FormControl>
              {isOther && (
                <TextField
                  id="otherReason"
                  name="otherReason"
                  label="Reason"
                  multiline
                  rowsMax="6"
                  value={otherReason}
                  className={classes.textFieldFullWidth}
                  margin="normal"
                  fullWidth
                  InputLabelProps={labelProps}
                  InputProps={{
                    classes: {
                      underline: classes.cssUnderline,
                    },
                    inputProps: {
                      maxLength: 500,
                    },
                  }}
                  error={errors.otherReason ? true : false}
                  helperText={errors.otherReason}
                  onChange={this.onFormFieldChange}
                />
              )}
            </Grid>
            <Grid item align="right">
              <Button className={classes.reportBtn} onClick={this.handleSubmit} disabled={!this.isValid()}>
                {loading ? <CircularProgress size={16} className={classes.buttonProgress} /> : 'Report'}
              </Button>
            </Grid>
          </form>
        </Popover>
      </div>
    )
  }
}

ReasonForm.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  propertyId: PropTypes.string,
  propertyRemoved: PropTypes.func,
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showFlashMessage,
      showFlashMessageOnUnexpectedError,
      flagProperty,
    },
    dispatch
  )
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ReasonForm)
)



// WEBPACK FOOTER //
// ./src/components/ReasonForm.js